import kinetikApi from './kinetikAPI';

const V2_BASE_URL = `${process.env.KINETIK_SERVICES_API_URL.replace(/\/v1$/, '/v2')}`;

export default {
  getReconciliations: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/reconciliation-sessions/search`, {
        ...options,
        baseURL: V2_BASE_URL,
      })
      .then((res) => res.data),
  getReconciliationDetail: (orgResourceId, reconciliationId) =>
    kinetikApi
      .get(`/${orgResourceId}/reconciliation-sessions/${reconciliationId}`, {
        baseURL: V2_BASE_URL,
      })
      .then((res) => res.data),
  resolveReconciliation: (orgResourceId, reconciliationId, payload) =>
    kinetikApi
      .post(
        `/${orgResourceId}/reconciliation-sessions/${reconciliationId}/resolve`,
        payload,
        {
          baseURL: V2_BASE_URL,
        },
      )
      .then((res) => res.data),
};
